import { Module } from 'vuex'
import { RootState, SupportPreferencesState } from './state_models'

export const supportPreferences: Module<SupportPreferencesState, RootState> = {
  namespaced: true,
  state: {
    showLockout: true,
    disableCustomJs: false,
    disableCustomCss: false,
    forceEnglishLocale: false,
  },
  getters: {
    isLockoutSkipped(state, _getters, _rootState, rootGetters): boolean {
      return rootGetters['auth/isSupportAgent'] && !state.showLockout
    },
    isCustomJsDisabled(state, _getters, _rootState, rootGetters): boolean {
      return rootGetters['auth/isSupportAgent'] && state.disableCustomJs
    },
    isCustomCssDisabled(state, _getters, _rootState, rootGetters): boolean {
      return rootGetters['auth/isSupportAgent'] && state.disableCustomCss
    },
    isEnglishLocaleForced(state, _getters, _rootState, rootGetters): boolean {
      return rootGetters['auth/isSupportAgent'] && state.forceEnglishLocale
    },
  },
  mutations: {
    setShowLockout(state, value: boolean) {
      state.showLockout = value
    },
    setDisableCustomCss(state, value: boolean) {
      state.disableCustomCss = value
    },
    setDisableCustomJs(state, value: boolean) {
      state.disableCustomJs = value
    },
    setForceEnglishLocale(state, value: boolean) {
      state.forceEnglishLocale = value
    },
  },
  actions: {
    setSupportPreferences({ commit }, data: SupportPreferencesState) {
      commit('setShowLockout', data.showLockout)
      commit('setDisableCustomCss', data.disableCustomCss)
      commit('setDisableCustomJs', data.disableCustomJs)
      commit('setForceEnglishLocale', data.forceEnglishLocale)
    },
  },
}
